<template>
  <div class="popup-delete" @mousedown.self="$emit('close')">
    <div class="popup-content-update">
      <div class="header-popup-update">
        <span>Modification de votre article </span>
        <span title="Annuler" style="float:right;" class="cross" @click="$emit('close')">&times;</span>
      </div>
      <hr />
      <input type="text" maxlength="40" placeholder="Titre de la catégorie" v-model="tempObject.Label" id="label">
      <div class="buttons">
        <button class="cancel" @click="$emit('close')">Annuler</button>
        <button class="publish" @click="$emit('updateCateg',tempObject)">Modifier</button>
      </div>
      </div>
    </div>
</template>

<script>

  export default {
    name: 'CmsDelete',
    props: {
      categ: Object //Catégorie passée en tant qu'objet
    },
    data() {
      return {
        tempObject: {}
      }
    },
    mounted() {
      var obj = { //On créer une categ temporaire (evite le changement dans le composant parent)
        Id: this.categ.Id,
        Label: this.categ.Label,
        CreatorGuid: this.categ.CreatorGuid
      }
      this.tempObject = obj;
    }
  };
</script>


<style>

  .main-content{
    width: 100%;
    height: 60%;
  }
  .buttons button {
    margin-right: 1%;
    color: white;
    font-family: 'DIN Pro';
    border: none;
  }

  .btn-cancel {
    background: #c1c1c1;

  }
  .icon-delete {
    color: #ee3535;
  }
  .btn-cancel:hover {
    background: #a8a8a8;
  }

  .btn-supp {
    background: #f15e5e;
  }
    .btn-supp:hover {
      background: #ee3535;
    }
  .popup-delete {
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(155, 155, 155, 0.8);
  }

    .popup-delete > .popup-content-update {
      margin: 70px auto;
      padding: 20px;
      background: #fff;
      border-radius: 5px;
      width: 50%;
      max-height: 80%;
      position: relative;

    }
  #label {
    border: 1px solid lightgrey;
    margin-left: 0%;
    height: 40px;
    font-size: 1.5rem;
    width: 50%;
  }
  .header-popup-update .cross {
    cursor: pointer;
  }

  .buttons {
    width: 100%;
    margin-top: 2%;
    display: flex;
    text-align:center;
    justify-content:right;
  }

  .container-buttons {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
  }

  .buttons .container-buttons button {
    margin-right: 1%;
    color: white;
    font-family: 'DIN Pro';
    border: none;
  }
  .buttons .container-buttons label {
    margin-right: 3%;
  }

  .buttons .container-buttons .form-select {
    width: 25%;
    margin-right: 3%;
  }

  .cancel {
    background: #FF5252;
  }

  .publish {
    background: #198754;
  }

  .cancel:hover {
    background: #d14646;
  }

  .publish:hover {
    background: #146741;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cms/CmsUpdateCategory.vue